import { HTTPImageryProvider } from "./HTTPImageryProvider";
import { WebMercatorTilingScheme } from "../../math/tiling";
/**
 * Internal class used for handling loading from open street maps
 */
export class OpenStreetMapImageryProvider extends HTTPImageryProvider {
    constructor() {
        super(new WebMercatorTilingScheme(), {
            minLevel: 0,
            maxLevel: 19,
        });
        this.urlIndex = 0;
        this.baseUrls = [
            "https://a.tile.openstreetmap.org/",
            "https://b.tile.openstreetmap.org/",
            "https://c.tile.openstreetmap.org/",
        ];
    }
    resolveTilePath(x, y, zoomLevel) {
        // Alternate through each provided URL
        const urlIndex = this.urlIndex;
        this.urlIndex = (this.urlIndex + 1) % this.baseUrls.length;
        return `${this.baseUrls[urlIndex]}${zoomLevel}/${x}/${y}.png`;
    }
    resolveRequestOptions() {
        return undefined;
    }
}
